export const whiteColors = ['#8d15e8', '#e014ad', '#e02214'];
